import Collapsable from './collapsable';
import StickyHeader from './utils/StickyHeader';
import Tabs from './components/Tabs/Tabs';
import { initializeServiceLink } from './components/ServiceLink/ServiceLink';
import ValuesGrid from './components/ValuesGrid/ValuesGrid';

import initForms from './form';
import initHubSearch from './components/HubSearch';

import '../css/style.less';
import '@rmwc/icon/styles';
import '@rmwc/select/styles';
import '@rmwc/radio/styles';

import TriggerViewport from './trigger-viewport';

const init = () => {
  new TriggerViewport({ threshold: 0.3 });

  new Collapsable({
    triggerClass: 'js--collapsable',
    collapsableClass: 'js--collapsable-content',
    toggleClass: 'is-open',
  });

  const complaintForm = document.querySelector('.js--complaintform');

  if (complaintForm) {
    initForms(complaintForm, 'complaint');
  }

  const contactForm = document.querySelector('.js--contactform');

  if (contactForm) {
    initForms(contactForm, 'contact');
  }

  const reportForm = document.querySelector('.js--reportform');

  if (reportForm) {
    initForms(reportForm, 'report');
  }

  if (StickyHeader && document.querySelector('.header--mobile')) {
    StickyHeader(window, document);
  }

  // Service Link
  initializeServiceLink();

  // Tabs
  const tabLinks = document.querySelectorAll('.tab__link');
  const tabContent = document.querySelectorAll('.tab__content');
  if (tabLinks.length > 0 && tabContent.length > 0) {
    Tabs(tabLinks, tabContent);
  }

  // Forms
  const forms = document.querySelectorAll('.js--form');
  if (forms) {
    forms.forEach((form) => {
      const submit = form.querySelector('.submit');

      if (!submit) return;

      form.addEventListener('submit', () => {
        submit.classList.add('onsubmit');
      });
    });
  }

  // hub search forms
  const hubSearch = document.querySelector('#js--hubsearch');

  if (hubSearch) {
    initHubSearch(hubSearch);
  }

  // Nav Search
  const NavSearch = document.querySelectorAll('.js--nav-search');
  if (NavSearch) {
    for (let i = 0; i < NavSearch.length; i++) {
      NavSearch[i].addEventListener('click', function () {
        this.classList.add('nav__link--fade');

        let inputSearch = this.parentNode.querySelector('.input--headersearch');
        if (inputSearch) {
          inputSearch.classList.add('open');
          inputSearch.focus();
        }

        if (this.parentNode.classList.contains('is-mobile')) {
          let buttonSearch = this.parentNode.querySelector(
            '.submit--headersearch'
          );
          buttonSearch.classList.toggle('submit--right');
        }
      });
    }
  }

  // Mobile nav
  const mobilenavButton = document.querySelector('.js--button-mobilenav');
  const mobilenav = document.querySelector('.js--mobilenav');
  if (mobilenavButton) {
    mobilenavButton.addEventListener('click', function () {
      this.classList.toggle('open');

      if (mobilenav) {
        mobilenav.classList.toggle('open');
      }

      document.body.classList.toggle('overflow--hidden');
    });
  }

  // Submenu
  const subMenu = document.querySelectorAll('.js--submenu');
  if (subMenu) {
    for (let i = 0; i < subMenu.length; i++) {
      subMenu[i].addEventListener('click', function () {
        const menu = this.parentNode.querySelector('.nav__submenu');

        if (menu) {
          this.classList.toggle('is-open');
          this.classList.toggle('nav__toggleicons--open');
          menu.classList.toggle('nav__submenu--open');
        }
      });
    }
  }

  // HomePage bloc component animation
  let blocs = document.querySelectorAll('.js--bloc-animation');

  if (blocs) {
    blocs.forEach((bloc) => {
      const ornaments = bloc.querySelectorAll('.js--ornament');
      const top = bloc.offsetTop;
      let posLeft = 0;
      let count;

      window.addEventListener('scroll', () => {
        // check if window position is close to element engage point
        if (window.pageYOffset > top - window.innerHeight / 2) {
          count = window.pageYOffset - (top - 500);
          if (count > 0 && count < 1500) {
            posLeft = -count / 5;
          }
        }

        // Make node list into an Array because, IE11
        Array.prototype.slice.call(ornaments).forEach((ornament) => {
          ornament.style.setProperty(
            'transform',
            'translateX(' + posLeft + 'px)'
          );
        });
      });
    });
  }

  // case note select all
  const selectAllCaseNotes = document.querySelectorAll('.js--selectAll');

  if (selectAllCaseNotes.length) {
    for (let i = 0; i < selectAllCaseNotes.length; i++) {
      const allCheckbox = selectAllCaseNotes[i];

      allCheckbox.addEventListener('change', (e) => {
        const el = e.target;
        const isChecked = el.checked;
        const filterList = el.closest('.js--filterlist');

        if (filterList) {
          let checkboxes = filterList.querySelectorAll(
            'input[type="checkbox"]'
          );

          for (let i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = isChecked;

            // If checkbox is unchecked, 'all' checkbox becomes unchecked
            checkboxes[i].addEventListener('change', (ea) => {
              if (!ea.target.checked) {
                allCheckbox.querySelector(
                  'input[type="checkbox"]'
                ).checked = false;
              }
            });
          }
        }
      });
    }
  }

  const printButton = document.querySelector('.js--print');

  if (printButton) {
    printButton.addEventListener('click', (e) => {
      e.preventDefault();

      window.print();
    });
  }

  /* Read more and read less functionality */
  const readMoreElements = document.querySelectorAll('.js--readmore');
  const readLessElements = document.querySelectorAll('.js--readless');

  if (readMoreElements) {
    readMoreElements.forEach((readmore) => {
      readmore.addEventListener('click', (e) => {
        const el = e.target;
        const readLess = el.nextElementSibling.querySelector('.js--readless');

        el.hidden = true;
        readLess.hidden = false;
        el.nextElementSibling.hidden = false;

        el.nextElementSibling.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      });
    });
  }

  if (readLessElements) {
    readLessElements.forEach((readless) => {
      readless.addEventListener('click', (e) => {
        const el = e.target;

        el.hidden = true;
        el.parentNode.hidden = true;
        el.parentNode.previousElementSibling.hidden = false;

        el.parentNode.previousElementSibling.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      });
    });
  }

  // ValuesGrid
  const valuesGrid = document.querySelectorAll('.values-block');

  if (valuesGrid) {
    ValuesGrid(valuesGrid);
  }

  // remove no-js class
  document.documentElement.classList.remove('no-js');

  // add lights-on class to body
  document.body.classList.add('lights-on');
};

if (document.readyState !== 'loading') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    init();
  });
}
